import OffreDemandeController from './offre.demande.controller';
import Template from './offre.demande.html';

export default {
	bindings: {
		offre: '=',
		isOpen: '=',
		dateDemandeCreation: '=',
		calculerDateFinDemande: '&',
		calculerDateFinDebutLivraison: '&',
		getTooltipCalculDate: '&'
	},
	template: Template,
	controller: OffreDemandeController
};
